import { render, staticRenderFns } from "./style-test-answer.vue?vue&type=template&id=af7c1c4e&scoped=true&"
import script from "./style-test-answer.vue?vue&type=script&lang=js&"
export * from "./style-test-answer.vue?vue&type=script&lang=js&"
import style0 from "./style-test-answer.vue?vue&type=style&index=0&id=af7c1c4e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7c1c4e",
  null
  
)

export default component.exports